import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceFiscalAssessmentDocumentApproveProps {
  documentId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceFiscalAssessmentDocumentApprove = ({
  documentId,
  options,
}: UseMaintenanceFiscalAssessmentDocumentApproveProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceFiscalAssessmentDocumentApprove'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/fiscal_assessment_documents/${documentId}/review`, {
        last_review_attributes: {
          state: 'approved',
        },
      });
    },
    ...options
  });
}
